import { render, staticRenderFns } from "./manufacturerManage.vue?vue&type=template&id=1244214c&scoped=true"
import script from "./manufacturerManage.vue?vue&type=script&lang=js"
export * from "./manufacturerManage.vue?vue&type=script&lang=js"
import style0 from "./manufacturerManage.vue?vue&type=style&index=0&id=1244214c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244214c",
  null
  
)

export default component.exports